import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiciosService } from 'src/app/services/servicios.service';
import { AlertController, LoadingController, Platform } from '@ionic/angular';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Hotspot, HotspotNetwork } from '@ionic-native/hotspot/ngx';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cambio-tel-pass',
  templateUrl: './cambio-tel-pass.page.html',
  styleUrls: ['./cambio-tel-pass.page.scss'],
})
export class CambioTelPassPage implements OnInit {
  controlTiempo:Boolean = false;
  tipo: string;
  nombre_usuario:string;
  validado: Boolean = false;
  telefono: string;
  mensaje: any;
  pass = {    
    password: '',
    password2:''
  };
  cambioPass:any;
  cambioTel:any;
  posicion:any = null;
  wifis : any[] = [];
  loading: any;

  public codigoColor = environment.personalizado.codigoColor;

  constructor(private rutaActiva: ActivatedRoute,
              private serv: ServiciosService,
              private alertCtrl: AlertController,
              private geo:Geolocation,
              private hotspot: Hotspot,
              private ld: LoadingController,
              private router: Router,
              private auth: AuthService,
              private plat: Platform) { }

  ngOnInit() {  
    this.tipo = this.rutaActiva.snapshot.params.tipo;
    this.nombre_usuario = this.rutaActiva.snapshot.params.nombre;
    this.telefono = localStorage.getItem('telefono');
    if(this.tipo=='telefono') {
      this.validado=true;
    }
    if (this.plat.platforms().find((plata => plata.toUpperCase() === 'ANDROID'))) {
      this.hotspot.scanWifi().then((networks: HotspotNetwork[]) => {
        this.wifis = networks;
      });
    }
    let watch = this.geo.watchPosition();
    watch.subscribe((data) => {
      this.posicion = data;
    });
  }
  async presentLoading() {
    this.loading = await this.ld.create({
      message: 'Procesando...',
    });
    await this.loading.present();
  }
  async onSubmitTemplate() {
    if(this.auth.sigueEnSesion()) {
      this.controlTiempo = false;
      let wif = '';
      let latitud = '';
      let longitud = '';    
      await this.presentLoading();    
      if (this.wifis.length > 0) {
        for (let index = 0; index < this.wifis.length; index++) {
          if (this.wifis.length - 1 == index) {
            wif += this.wifis[index].SSID;
          } else {
            wif += this.wifis[index].SSID + '$';
          }
        }
      }
      try {
        if ((this.posicion !== null) && (this.posicion != 'undefined')) {
          if(this.posicion.coords != null && this.posicion.coords != undefined) {
            latitud = this.posicion.coords.latitude;
            longitud = this.posicion.coords.longitude;
          }
        }    
      } catch (e) {
        console.log(e);
      }
      this.mensaje = null;
      let subscripcion: any;
      
      if(this.tipo == 'telefono') {        
        subscripcion = this.serv.setCambiaTelefono(this.telefono, latitud, longitud, wif).subscribe((data)=>{
          this.controlTiempo = true;
          this.mensaje = data;
          if(this.loading != null) {
            this.loading.dismiss();
          }
          if(this.mensaje != null) {
            localStorage.removeItem('telefono');
            localStorage.setItem('telefono', this.telefono);
            this.presentAlert(this.mensaje.mensaje);
            if (this.mensaje.id != 3 ) {
              this.serv.setCambioTelefono(this.telefono, this.nombre_usuario).subscribe((data) => {
                this.cambioTel = data;
              });    
            }
          }
        });

      }else {
        if(this.tipo == 'password') {
          subscripcion = this.serv.setCambiaPassword(this.pass.password, latitud, longitud, wif, localStorage.getItem('id_plataforma') ).subscribe((resp) => {
            this.controlTiempo = true;
            this.mensaje = resp;
            if (this.loading != null) {
              this.loading.dismiss();
            }
            if(this.mensaje != null) {
              this.pass.password = '';
              this.pass.password2 = '';
              this.presentAlert(this.mensaje.mensaje);
              if(this.mensaje.id != 3) {
                  this.serv.setCambioPassword(this.telefono, this.nombre_usuario).subscribe((data) => {
                  this.cambioPass = data;            
                });   
              }
            }
          });
        }
      }    
      setTimeout(() => {
        if (!this.controlTiempo) {
          subscripcion.unsubscribe();
          if ((this.loading != null) && (this.loading != undefined)) {
            this.loading.dismiss();
          }
          this.presentAlertError('La conexión esta tardando demasiado, por favor inténtelo de nuevo pasados unos momentos');
        }
      }, 1000 * 10);     
    }
  }
  limpiaTodo(){
    if(this.auth.isAuthenticated()) {
      if(this.tipo =='telefono') {
        this.telefono = '';
      }else{
        this.pass.password = '';
        this.pass.password2 = '';
      }
    }
  }
  introducePass(caracter: String) {
    if (this.pass.password.length < 4) {
      this.pass.password += caracter;
    } else {
      if (this.pass.password2.length < 4) {
        this.pass.password2 += caracter;
      }
    }
  }
  introduceTel(caracter: String) {
    if (this.telefono.length < 9) {
      this.telefono += caracter;
    }
  }
  comprueba() {
    if((this.pass.password == this.pass.password2)&&(this.pass.password.length==4)&&(this.pass.password2.length==4)) {
      this.validado = true;
    } else {
      this.validado = false;
    }
  }
  compruebaTel(){
    if(this.telefono.length < 9) {
      this.validado = false;
    }else {
      this.validado = true;
    }
  }
  borra() {
    if(this.tipo == 'telefono'){
      if(this.telefono.length > 0) {
        this.telefono = this.telefono.slice(0, -1);
      }
    }else {
      if (this.pass.password2.length > 0) {
        this.pass.password2 = this.pass.password2.slice(0, -1);
      }else {
        if (this.pass.password.length > 0) {
          this.pass.password = this.pass.password.slice(0, -1);
        }
      }
    }
  }
  async presentAlert(mensaje: string) {
    const alert = await this.alertCtrl.create({
      subHeader: mensaje,
      buttons: [{
        text: 'Ok',
        handler: () => {
          if(this.mensaje.id == 1) {
            this.router.navigate(['/marcaje/0']); 
          }
        }
      }]
    });
    await alert.present();
  }
  async presentAlertError(mensaje: string) {
    const alert = await this.alertCtrl.create({
      subHeader: mensaje,
      buttons: [{
        text: 'Ok',
        handler: () => {
        }
      }]
    });
    await alert.present();
  }
  salir() {
    this.router.navigate(['/marcaje/0']);
  }
  abrirAyuda() {
    this.serv.abrirAyuda();
  }
}
